import { apiClient } from '../shared/api-client';

function validateEmail(email) {
    if (!email.trim()) {
        return {
            isValid: false,
            message: 'Email cannot be empty.'
        };
    }

    const isValidEmail = String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

    if (isValidEmail === null) {
        return {
            isValid: false,
            message: `The email ${email} may have a mistake or might not work.`
        };
    }

    return {
        isValid: true,
        message: ''
    };
}

async function asyncValidateEmail(email) {
    try {
        await apiClient.post({
            url: 'auth/email/validate',
            body: { email },
            isCheckAccessToken: false
        });

        return {
            isValid: true,
            message: ''
        };
    } catch (error) {
        if (error?.response.didYouMean) {
            return {
                isValid: false,
                message: `Did you mean ${error.response.didYouMean}?`,
                data: {
                    didYouMean: error.response.didYouMean
                }
            };
        }

        return {
            isValid: false,
            message: `The email ${email} may have a mistake or might not work.`
        };
    }
}

export {
    validateEmail,
    asyncValidateEmail
};
